import { usingPost } from '@ocean/api'

export const getPersons = (freetext = '') => usingPost('Personnel/ListPeople', { freetext })
